import React from 'react';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';

import { Form, Button } from 'react-bootstrap';

import * as turf from '@turf/turf';
import { Formik } from 'formik';
import * as yup from 'yup';

import { useStore } from '../../../providers/AppProvider';
import { Farm, Field, Grower, Variety } from '../../../types/types';
import { CREATE_FIELD, GET_FARMS, GET_GROWERS2, UPDATE_FIELD } from '../../../../../queries';
import { GetFarms, GetGrowers, landscan_fields_insert_input } from '../../../../../__generated__/types';
import { useMutation, useQuery } from 'react-apollo';
import { CreateGrower } from './CreateGrower';
import { CreateFarm } from './CreateFarm';
import { useRouteMatch } from 'react-router-dom';
import EditZoneImageForm from './EditZoneImageForm';
import LandscanService from '../../../api/landscanService';
import { useFormikContext } from 'formik';
import { useUnitConversion, formatUnitAbbreviation } from '../../../utils/unitConversion';
import _ from 'lodash';
import { dcRound } from '../../../utils/misc';

const schema = yup.object().shape({
    name: yup.string().required().max(255),
    description: yup.string(),//.required(),
    number_of_zones: yup.number()      
        .required('Number of zones is required')
        .positive('Number of zones must be positive')
        .integer('Number of zones must be an integer')
        .min(2, 'At least two zones are required')
        .max(20, 'A maximum of 20 zones are allowed'),
    x_y_scale: yup.number()      
        .required('XY scale is required')
        .positive('XY scale must be positive')
        .min(0.00, 'XY scale greater than or equal to 0 is required')
        .max(1.00, 'XY scale less than or equal to 1 is required'),
    min_area: yup.number()      
        .required('Min area is required')
        .positive('Min area must be positive')
        .min(0.0001, 'Min area greater than or equal to 0.0001 is required'),
    year_planted: yup.number(),
    acres: yup.number().positive('a valid block size is required'),
    zoneset_type: yup.string().required('zone set type is required'),
    select_collections: yup.array().required('collection is required'),
    select_date_years: yup.array().required('date years are required'),
    min_date_day: yup.number().required('date min day is required'),
    min_date_month: yup.number().required('date min month is required'),
    max_date_day: yup.number().required('date max day is required'),
    max_date_month: yup.number().required('date max month is required'),
    farm_id: yup.number(),
    crop_id: yup.number(),//.required('crop is required'),
    variety_id: yup.number(),
    plant_spacing: yup.number().positive('a valid plant spacing is required'),
    row_spacing: yup.number().positive('a valid row spacing is required'),
    url: yup.string().url().max(512)
});

type ZoneFormValues = {
    zoneset_type: string,
    farm_id: string,
    name: string,
    description:string,
    number_of_zones:string,
    x_y_scale:string,
    min_area:string,
    select_collections:string | any,
    select_date_years:string | any,
    min_date_day:string,
    min_date_month:string,
    max_date_day:string,
    max_date_month:string,
    crop_id: string,
    variety_id: string,
    year_planted: string,
    acres: string,
    plant_spacing: string,
    row_spacing: string,
    url: string,
};

const FIELD_APP_URL = process.env.REACT_APP_FIELD_MGR_ROOT_URL;

const EditZoneForm = (props: any) => {
    console.log("040324 props", props);
    const match = useRouteMatch(`${FIELD_APP_URL}/:vp/fields`);
    const history = useHistory();
    const { state: { crops, varieties }, orgId } = useStore();
    const { localePreferences } = useStore();
    const [sliderValue, setSliderValue] = useState(0.25);
    const [genericError, setGenericError] = useState<string | null>(null);

    //const { data: growerData } = useQuery<GetGrowers>(GET_GROWERS2);
    //const { data: farmData } = useQuery<GetFarms>(GET_FARMS);

    const [createField] = useMutation(CREATE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match.url}`);
        }
    });

    const [updateField] = useMutation(UPDATE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match.url}`);
        }
    });

    const [editField, setEditField] = useState<Field | null>(props.fieldToEdit);
    const [editZone, setEditZone] = useState<any>(props.zoneToEdit);
    const [currentCropVarieties, setCurrentCropVarieties] = useState<Variety[]>([]);
    const [currrentGrowerFarms, setCurrentGrowerFarms] = useState<Farm[]>([]);
    const [growers, setGrowers] = useState<Grower[]>([]);
    const [currentGrowerId, setCurrentGrowerId] = useState<number | null>(null);
    const [farms, setFarms] = useState<Farm[]>([]);

    const [feature, setFeature] = useState<any>(null);
    const [hasFeature, setHasFeature] = useState<boolean>(false);
    const [polling, setPolling] = useState<boolean>(false);
    const [featureArea, setfeatureArea] = useState<number | null>(null);
    const [defaultValues, setDefaultValues] = useState<ZoneFormValues>({
        zoneset_type: "Productivity Zones",
        farm_id: "",
        name: "Zone Set",
        description: "",
        number_of_zones: "5",
        x_y_scale: "0.25",
        min_area: "1",
        select_collections: ['VVI','PGI', 'TOANDRE'],
        select_date_years: ['2020','2021','2022','2023', '2024'],
        min_date_day: "1",
        min_date_month: "7",
        max_date_day: "30",
        max_date_month: "7",
        crop_id: "",
        variety_id: "",
        year_planted: "",
        acres: "",
        plant_spacing: "",
        row_spacing: "",
        url: ""
        /*zoneset_type: "",
        farm_id: "",
        name: "",
        description: "",
        number_of_zones: "",
        x_y_scale: "",
        select_collections: "",
        select_date_years: "",
        min_date_day: "",
        min_date_month: "",
        max_date_day: "",
        max_date_month: "",
        crop_id: "",
        variety_id: "",
        year_planted: "",
        acres: "",
        plant_spacing: "",
        row_spacing: "",
        url: ""*/
    });

    const [showCreateGrower, setShowCreateGrower] = useState<boolean>(false);
    const [showCreateFarm, setShowCreateFarm] = useState<boolean>(false);


    /*useEffect(() => {
        setGrowers(growerData ? growerData.landscan_growers.map(g => { 
            return {
                id: g.zoneset_type,
                name: g.name,
                description: g.description
            } as Grower
        }) : []);
    }, [growerData]);*/


    /*useEffect(() => {
        setFarms(farmData ? farmData.landscan_farms.map(f => { 
            return {
                id: f.farm_id,
                zoneset_type: f.zoneset_type,
                name: f.name,
                description: f.description
            } as any //Farm
        }) : []);
    }, [farmData]);*/


    /*useEffect(() => {
        // force to update the list of the current grower
        // when the data updates.
        if(currentGrowerId) {
            setGrowersFarms(currentGrowerId);
        }
    }, [farms]);*/


    /*useEffect(() => {
        setFeature(props.feature && props.feature.length ? props.feature[0] : null);
        setHasFeature(props.feature && props.feature.length);
    }, [props.feature]);


    useEffect(() => {
        setfeatureArea(feature ? calculateAcres(feature) : null);
    }, [feature]);*/


    const setCropVarieties = (cropId: number) => {
        setCurrentCropVarieties(cropId > 0 ? varieties.filter((v: Variety) => v.crop_id === cropId) : []);
    }


    //const setGrowersFarms = (growerId: number) => {
    //    setCurrentGrowerFarms(growerId > 0 ? farms.filter((f: Farm) => f.zoneset_type === growerId) : [])
    //}


    const years = (startYear: number) => {
        var currentYear = new Date().getFullYear(), years = [];
        startYear = startYear || 1980;
        while (startYear <= currentYear) {
            years.push(startYear++);
        }
        return years.reverse();
    }


    const calculateAcres = (geojsonFeature: any) => {
        const polygon = turf.polygon(geojsonFeature.geometry.coordinates);
        return turf.area(polygon) * 0.00024711
    }


    const onSubmit = async (data: ZoneFormValues) => {
        console.log("ZZ040624 data", data);
        setPolling(true);
        // convert to a multi-polygon since the edit only returns polygons
        /*let geometry = {...feature.geometry};
        geometry.coordinates = [geometry.coordinates];      
        geometry.type = "MultiPolygon";
        geometry.crs = {
            "type": "name",
            "properties": {
              "name": "urn:ogc:def:crs:EPSG::4326"
            }
        };*/
        /*
            {
                "name": "string",
                "description": "string",
                "numZones": 2,
                "xyScale": 1,
                "fieldId": 1,
                "dateMonthMin": 7,
                "dateMonthMax": 8,
                "dateDayMin": 1,
                "dateDayMax": 1,
                "stacSelector": "last",
                "years": "string",
                "properties": "string",
                "stacItemsToProcess": {}
            }
        */
        /*const zone: any landscan_fields_insert_input = {
            org_id: orgId,
            field_id: editField ? editField.id : undefined,
            name: data.name,
            description: data.description,
            number_of_zones: data.number_of_zones != "" ? parseInt(data.number_of_zones) : null,
            x_y_scale: data.x_y_scale != "" ? parseFloat(data.x_y_scale) : null,
            zoneset_type: data.zoneset_type != "" ? parseInt(data.zoneset_type) : null,
            farm_id: data.farm_id != "" ? parseInt(data.farm_id) : null,
            crop_id: data.crop_id != "" ? parseInt(data.crop_id) : null,
            variety_id: data.variety_id != "" ? parseInt(data.variety_id) : null,
            acres: data.acres != "" ? parseFloat(data.acres) : featureArea?.toFixed(2),
            plant_spacing: data.plant_spacing != "" ? parseFloat(data.plant_spacing) : null,
            row_spacing: data.row_spacing != "" ? parseFloat(data.row_spacing) : null,
            year_planted: data.year_planted != "" ? parseInt(data.year_planted) : null,
            url: data.url,
            geom: JSON.stringify(geometry)
        };
        console.log("040324 zone", zone);*/
       /* if (editField) {
            await updateField({ variables: {id: editField.id, data: field} } );
        } else {
            await createField({ variables: {data: field} } );
        }*/
        
        const mid = _.get(localePreferences, 'measureUnits.area.mid');
        const preferredAreaAbbr: string = typeof mid === 'string' ? mid : mid?.abbr || 'ac';
        const payload = {
            name: data.name,
            description: data.description == "" ?  "" : data.description,
            numZones: data.number_of_zones,
            xyScale: sliderValue, //data.x_y_scale,
            fieldId: editField ? editField.id : undefined,
            dateMonthMin: data.min_date_month != "" ? parseInt(data.min_date_month) : null,
            dateMonthMax: data.max_date_month != "" ? parseInt(data.max_date_month) : null,
            dateDayMin: data.min_date_day != "" ? parseInt(data.min_date_day) : null,
            dateDayMax: data.max_date_day != "" ? parseInt(data.max_date_day) : null,
            stacSelector: "last",
            years: data.select_date_years,
            properties: data.select_collections,
            stacItemsToProcess: null, //{}, 
            minArea: data.min_area != "" ? parseFloat(data.min_area) * 4046.86 : null, // Convert acres to meters squared
            /*minArea: data.min_area != "" 
                ? preferredAreaAbbr === 'ac'
                    ?  data.min_area != "" 
                        ? parseInt(data.min_area) * 4046.86 // Convert acres to meters squared
                        : null 
                    :  data.min_area != "" ? parseFloat(data.min_area) * 10000 : null // Convert hectares to meters squared
                : null,*/
        };
        console.log("081125 payload", payload);
        try {
            console.log("040524 payload", payload);
            //usePostCreateZoneSetPrelim(zone.field_id, zone); // We cant really do this because of react hooks
            const returned = await LandscanService.createZoneSetPrelim(payload as any) as any;
            console.log("040524 returned", returned);
            if (returned.mzCollectImageryJob && returned.mzSegmentaitonJob){
                setGenericError(null);
                beginPollingZoneJobs({
                    "CollectImagery" : returned.mzCollectImageryJob.id,
                    "Segmentation" : returned.mzSegmentaitonJob.id,
                });
            }else{
                console.log("040524 returned", returned);
                if (returned.data && returned.data.message) {
                    if (returned.data.statusCode){
                        if (returned.data.statusCode === 400){
                            setGenericError(`There was a problem creating your Zone Set with the provided options, check options and try again. ${returned.data.message}`);
                        }else{
                            setGenericError(`There was an error creating your Zone Set, try again. ${returned.data.message}`);
                        }
                    }else{
                        setGenericError(`There was an error creating your Zone Set, try again. ${returned.data.message}`);
                    }
                }
            }
        } catch (error) {
            // Handle the error
            console.error(error);
        }
    }

    const beginPollingZoneJobs = async (jobIds: any) => {
        const pollInterval = 5000; // 5 seconds
        const maxAttempts = 180; // Total attempts (5 seconds * 60 = 5 minutes of polling)
      
        const pollJob = async (jobId:any, attempt:any = 1):Promise<any> => {
          console.log(`040524 Polling job ${jobId}, attempt ${attempt}`);
          
          const statusData = await LandscanService.pollZoneCreationStatus(jobId);
          console.log("040524 statusData", statusData)
          props.setJobStatus(statusData?.status ? statusData?.status : "unknown");
          props.setJobPercent(statusData?.percent ? statusData?.percent : 0);
          if (statusData?.status === 'complete' || statusData?.status === 'failed') {
          
            // If the job is completed or failed, return the status data
            return statusData;
          } else if (attempt < maxAttempts) {
            // If the job is still in progress and max attempts are not reached, poll again after the interval
            console.log("040524 POLL AGAIN")
            await new Promise(resolve => setTimeout(resolve, pollInterval));
            return pollJob(jobId, attempt + 1);
          } else {
            // If max attempts are reached, throw an error
            setPolling(false);
            return `Job ${jobId} timed out`;
            //throw new Error(`Job ${jobId} did not complete within the expected time.`);
          }
        };
      
        try {
            // Use Promise.all to poll both jobs in parallel
            const results = await Promise.all([
                pollJob(jobIds.CollectImagery),
                //props.setJobPercent(0),
                props.setJobRunning("Creating Zoneset")
            ]);

            // Process results
            console.log("040524 POLL", results);
            if (results[0].percent) {
                props.setJobPercent(results[0].percent);
            }
            if (results[0].status === "complete") {
                console.log("040524 COMPLETE", jobIds.CollectImagery);
                setPolling(false);
                props.setJobRunning("")
                props.setUpdateToNewPrelimSet(true);
                props.setSelectedZonesetStatus("prelim");
                props.setUpdateZonesets((prev:number) => {
                    return prev + 1;
                });
            }
            if (results[0].status === "failed") {
                setPolling(false);
                props.setJobRunning("")
            }
            // Additional logic to handle completed jobs
        } catch (error) {
          // Handle any errors that occurred during polling
          console.error("An error occurred during job polling:", error);
        }
    };

    useEffect(() => {
        setEditField(props.fieldToEdit);

        /*if (props.fieldToEdit) {
            // crop is required
            setCropVarieties(props.fieldToEdit['crop_id']);

            // could be null, not required, null ok
            setCurrentGrowerId(props.fieldToEdit['zoneset_type']);

            // only if not null
            //if(props.fieldToEdit['zoneset_type']) {
            //    setGrowersFarms(props.fieldToEdit['zoneset_type']);
            //}

            let resetValues: ZoneFormValues = {} as ZoneFormValues;
            const fields = ['name', 
                            'description',
                            'number_of_zones',
                            'x_y_scale',
                            'zoneset_type', 
                            'farm_id', 
                            'crop_id', 
                            'acres', 
                            'plant_spacing', 
                            'row_spacing', 
                            'year_planted', 
                            'variety_id', 
                            'url'];
            //fields.forEach(f => resetValues[f as keyof ZoneFormValues] = "");//props.fieldToEdit[f] ? props.fieldToEdit[f] as string : '');
            //fields.forEach(f => resetValues[f as keyof ZoneFormValues] = defaultValues[f] ? defaultValues[f] as string : '');
            
            setDefaultValues(resetValues);
        }*/
    }, [props.fieldToEdit]);

    // Keeps Formik's values.min_area in ACRES (DB truth).
    // Lets the user see/type in preferred area units (area.mid).
    function MinAreaInput() {
        const { values, errors, setFieldValue, handleBlur } = useFormikContext<ZoneFormValues>();
        const { localePreferences } = useStore();
        const { unitsConvert, convertToPreferredUnitValue } = useUnitConversion();

        // Local display value (preferred units)
        const [display, setDisplay] = useState<string>('');
        const [isEditing, setIsEditing] = useState<boolean>(false);

        // Determine preferred area mid abbr (supports object or string in prefs)
        const mid = _.get(localePreferences, 'measureUnits.area.mid');
        const preferredAreaAbbr: string = typeof mid === 'string' ? mid : mid?.abbr || 'ac';

        // Read Formik's stored value (in acres)
        const acresRaw = values.min_area;

        // Sync Formik (acres) -> UI (preferred) when not editing
        useEffect(() => {
            if (isEditing) return;

            const acres = acresRaw !== '' ? Number(acresRaw) : NaN;
            if (Number.isFinite(acres)) {
            const asPreferred = convertToPreferredUnitValue(acres, 'ac', 'area', 'mid');
            setDisplay(
                asPreferred == null ? '' : String(dcRound(asPreferred as number, false, [false, 2], true))
            );
            } else {
            setDisplay('');
            }
        }, [acresRaw, convertToPreferredUnitValue, isEditing]);

        // Allow transitional input while typing: '', '.', '0.', '12.'
        const INPUT_OK = /^[0-9]*[.,]?[0-9]*$/;

        const onFocus: React.FocusEventHandler<HTMLInputElement> = () => {
            setIsEditing(true);
        };

        const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
            const s = e.currentTarget.value;

            if (!INPUT_OK.test(s)) return; // reject non-numeric chars
            setDisplay(s);

            // Transitional states — keep Formik empty
            if (s === '' || s === '.' || s === ',') {
            setFieldValue('min_area', '');
            return;
            }

            const parsed = Number(String(s).replace(/,/g, ''));
            if (!Number.isFinite(parsed)) {
            setFieldValue('min_area', '');
            return;
            }

            try {
            // Convert preferred -> acres for Formik
            const acres = unitsConvert(parsed, preferredAreaAbbr, 'ac');
            setFieldValue('min_area', acres);
            } catch {
            // keep last known value if conversion fails
            }
        };

        const onBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
            handleBlur(e);
            setIsEditing(false);

            const s = display;
            if (s === '' || s === '.' || s === ',') return;

            const parsed = Number(String(s).replace(/,/g, ''));
            if (!Number.isFinite(parsed)) return;

            try {
            // Ensure Formik has final acres
            const acres = unitsConvert(parsed, preferredAreaAbbr, 'ac');
            setFieldValue('min_area', acres);

            // Recompute pretty display
            if (acres !== undefined) {
                const asPreferred = convertToPreferredUnitValue(acres, 'ac', 'area', 'mid');
                if (asPreferred != null) {
                    setDisplay(String(dcRound(asPreferred as number, false, [false, 2], true)));
                }
            }
            } catch {
            // no-op
            }
        };

        return (
            <Form.Group className="mb-3">
            <Form.Label>
                Min Area
                <span className="text-muted"> ({formatUnitAbbreviation(preferredAreaAbbr)})</span>
            </Form.Label>
            <Form.Control
                type="text"
                name="min_area_display"
                size="sm"
                placeholder={`Enter minimum area in ${formatUnitAbbreviation(preferredAreaAbbr)}`}
                value={display}
                onFocus={onFocus}
                onChange={onChange}
                onBlur={onBlur}
                isInvalid={!!errors.min_area}
                autoComplete="off"
            />
            <Form.Control.Feedback type="invalid">
                {errors.min_area}
            </Form.Control.Feedback>
            </Form.Group>
        );
    }

    

    const handleSliderChange = (event:any) => {
        //handleChange(event);
        setSliderValue(event.target.value);
    };

    return (
        <div className="d-flex flex-column h-100 pb-2">
            <CreateGrower isOpen={showCreateGrower} onClose={() => setShowCreateGrower(false)} />
            <CreateFarm isOpen={showCreateFarm} onClose={() => setShowCreateFarm(false)} />
            <div className="p-3">
                <h4>{editZone ? 'Edit Zone Set' : 'New Zone Set'}</h4>
                <h6>{`${editField && editField.farm ? editField.farm?.name + " " : ""}${editField ? editField.name : ""}`}</h6>
            </div>
            <div className="flex-grow-1 pt-0 pb-2 px-3 pt-2" style={{flexBasis: 0}}>
                <Formik
                    enableReinitialize={true}
                    initialValues={defaultValues}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={async (values, { setSubmitting }) => {
                        console.log("ZZ040624 submitting..." )
                        console.log("ZZ040624 values", values )
                        // if we made it this far, the form validation passed.
                        // check for kinks in the polygon.
                        //const featureCol = turf.kinks(feature);
                        //if(featureCol.features.length > 0) {
                        //    alert('The block polygon is invalid. A polygon that overlaps itself is not allowed.');
                        //    return;
                        //}
                        setSubmitting(true);
                        await onSubmit(values);
                    }}
                >
                    {({
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                    }) => {

                        //console.log("ZZ040624 values", values);
                        //console.log("ZZ040624 touched", touched);


                        /*
                        
                            if (values.x_y_scale) {
                                setFieldValue('select_collections', defaultValues.select_collections, false);
                                setFieldValue('name', defaultValues.name, false);
                                setFieldValue('number_of_zones', defaultValues.number_of_zones, false);
                                setFieldValue('x_y_scale', defaultValues.x_y_scale, false);
                                setFieldValue('select_date_years', defaultValues.select_date_years, false);
                                setFieldValue('min_date_day', defaultValues.min_date_day, false);
                                setFieldValue('min_date_month', defaultValues.min_date_month, false);
                                setFieldValue('max_date_day', defaultValues.max_date_day, false);
                                setFieldValue('max_date_month', defaultValues.max_date_month, false);
                            }
                        */
                          
                        return (
                            <Form noValidate onSubmit={handleSubmit} autoComplete="off" className="d-flex flex-column h-100 justify-content-between">
                                <div>
                                <Form.Group>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="zoneset_type"
                                                size="sm"
                                                value={values.zoneset_type}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.zoneset_type}
                                                onChange={e => {
                                                    handleChange(e);
                                                    //setFieldValue('farm_id', ""); // reset farm
                                                    //setCurrentGrowerId(e.currentTarget.value ? parseInt(e.currentTarget.value) : null);
                                                    //setGrowersFarms(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                                }}
                                            >
                                                <option value="" label="Select a zone set type" disabled />
                                                {[{id:"productivity_zones", name:"Productivity Zones"}].map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                            {/*<Button size="sm" className="ml-2" title="Create" onClick={() => setShowCreateGrower(true)}>
                                                +
                                            </Button>*/}
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.zoneset_type}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            size="sm"
                                            placeholder="Enter zone set name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="description"
                                            size="sm"
                                            placeholder="Enter zone set description"
                                            value={values.description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.description}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.description}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Number of Management Zones</Form.Label>
                                        <Form.Control
                                            type="number"
                                            min="2"
                                            max="20"
                                            name="number_of_zones"
                                            className={errors.number_of_zones && touched.number_of_zones ? 'input-error' : ''}
                                            size="sm"
                                            placeholder="Enter the number of zones to create"
                                            value={values.number_of_zones}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            /* Automatically reset to the max min value if exceeded. */
                                            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const value = parseInt(e.target.value, 10);
                                                if (value < 2) e.target.value = "2";
                                                if (value > 20) e.target.value = "20";
                                            }}
                                            isInvalid={!!errors.number_of_zones}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.number_of_zones}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Spatial Factor</Form.Label>
                                        <br></br>
                                        <input
                                            type="range"
                                            min="0.00"
                                            max="1.00"
                                            step="0.01"
                                            name="x_y_scale"
                                            className={`form-range ${errors.x_y_scale && touched.x_y_scale ? 'input-error' : ''}`}
                                            style={{width:"100%"}}
                                            value={sliderValue}
                                            onChange={handleSliderChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.x_y_scale && (
                                            <div className="invalid-feedback d-block">
                                                {errors.x_y_scale}
                                            </div>
                                        )}
                                        <div className="d-flex justify-content-between">
                                            <div style={{color:"#818182"}}>0.00</div>
                                            <div style={{display: "inline-flex"}}>
                                                <div style={{color:"#818182", paddingRight:"5px"}}>Selected:</div><div style={{fontWeight:"bold"}}>{sliderValue}</div>
                                            </div>
                                            <div style={{color:"#818182"}}>1.00</div>
                                        </div>
                                        
                                    </Form.Group>
                                    <MinAreaInput />
                                    <Form.Group className="mb-3">
                                        <Form.Label>Select Collections</Form.Label>
                                        <Form.Control
                                            name="select_collections"
                                            as="select"
                                            multiple
                                            className={errors.select_collections && touched.select_collections ? 'input-error' : ''}
                                            size="sm"
                                            //placeholder="Enter the XY scale"
                                            value={values.select_collections}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.select_collections}
                                        >
                                            <option value="" label="Select collections" disabled />
                                                {[
                                                    {id:"VVI", name:"VVI"},
                                                    {id:"PGI", name:"PGI"},
                                                    //{id:"CCCI", name:"CCCI"},
                                                    {id:"TOANDRE", name:"TOANDRE"},
                                                    {id:"TOANDVI", name:"TOANDVI"},

                                                ].map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.select_collections}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Select Date Years</Form.Label>
                                        <Form.Control
                                            name="select_date_years"
                                            as="select"
                                            multiple
                                            className={errors.select_date_years && touched.select_date_years ? 'input-error' : ''}
                                            size="sm"
                                            placeholder="Enter the XY scale"
                                            value={values.select_date_years}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.select_date_years}
                                        >
                                            <option value="" label="Select image date year" disabled />
                                                {[
                                                    {id:"2014", name:"2014"},
                                                    {id:"2015", name:"2015"},
                                                    {id:"2016", name:"2016"},
                                                    {id:"2017", name:"2017"},
                                                    {id:"2018", name:"2018"},
                                                    {id:"2019", name:"2019"},
                                                    {id:"2020", name:"2020"},
                                                    {id:"2021", name:"2021"},
                                                    {id:"2022", name:"2022"},
                                                    {id:"2023", name:"2023"},
                                                    {id:"2024", name:"2024"},
                                                    {id:"2025", name:"2025"},
                                                    {id:"2026", name:"2026"},
                                                ].reverse().map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.select_date_years}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <div className="d-flex">
                                        <Form.Group className="mr-2">
                                        <Form.Label>Select Min Date Month</Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="min_date_month"
                                                size="sm"
                                                value={values.min_date_month}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.min_date_month}
                                                onChange={e => {
                                                    handleChange(e);
                                                    //setFieldValue('farm_id', ""); // reset farm
                                                    //setCurrentGrowerId(e.currentTarget.value ? parseInt(e.currentTarget.value) : null);
                                                    //setGrowersFarms(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                                }}
                                            >
                                                <option value="" label="Select a zone set type" disabled />
                                                {[
                                                    {id:"1", name:"January"},
                                                    {id:"2", name:"February"},
                                                    {id:"3", name:"March"},
                                                    {id:"4", name:"April"},
                                                    {id:"5", name:"May"},
                                                    {id:"6", name:"June"},
                                                    {id:"7", name:"July"},
                                                    {id:"8", name:"August"},
                                                    {id:"9", name:"September"},
                                                    {id:"10", name:"October"},
                                                    {id:"11", name:"November"},
                                                    {id:"12", name:"December"}
                                                ].map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.min_date_month}
                                        </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Min Date Day</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max="31"
                                                name="min_date_day"
                                                className={errors.min_date_day && touched.min_date_day ? 'input-error' : ''}
                                                size="sm"
                                                placeholder="Select the min date day of the month for the image search "
                                                value={values.min_date_day}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.min_date_day}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.min_date_day}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="d-flex">
                                        <Form.Group className="mr-2">
                                        <Form.Label>Select Max Date Month</Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="max_date_month"
                                                size="sm"
                                                value={values.max_date_month}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.max_date_month}
                                                onChange={e => {
                                                    handleChange(e);
                                                    //setFieldValue('farm_id', ""); // reset farm
                                                    //setCurrentGrowerId(e.currentTarget.value ? parseInt(e.currentTarget.value) : null);
                                                    //setGrowersFarms(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                                }}
                                            >
                                                <option value="" label="Select a max month" disabled />
                                                {[
                                                    {id:"1", name:"January"},
                                                    {id:"2", name:"February"},
                                                    {id:"3", name:"March"},
                                                    {id:"4", name:"April"},
                                                    {id:"5", name:"May"},
                                                    {id:"6", name:"June"},
                                                    {id:"7", name:"July"},
                                                    {id:"8", name:"August"},
                                                    {id:"9", name:"September"},
                                                    {id:"10", name:"October"},
                                                    {id:"11", name:"November"},
                                                    {id:"12", name:"December"}
                                                ].map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.max_date_month}
                                        </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Max Date Day</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max="31"
                                                name="max_date_day"
                                                className={errors.max_date_day && touched.max_date_day ? 'input-error' : ''}
                                                size="sm"
                                                placeholder="Select the max date day of the month for the image search "
                                                value={values.max_date_day}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.max_date_day}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.max_date_day}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                                {/*!editZone
                                ? <EditZoneImageForm 
                                        fieldToEdit={editField}
                                        zoneToEdit={props.zoneToEdit}
                                        feature={feature}
                                    />
                                : null*/}
                                <div>             
                                    {genericError 
                                        ? <div
                                            style={{
                                                fontSize: "8pt",
                                                paddingBottom: "10px",
                                                color: "red",
                                            }}
                                        >
                                            {genericError}
                                        </div>
                                        : null
                                    }
                                    <div className="d-flex justify-content-between">
                           
                                        <div className="d-flex gap-2">
                                            <Button type="submit" variant="primary" size="sm" disabled={isSubmitting || polling}>
                                                {editZone ? 'Update' : 'Create'}
                                            </Button>
                                            <Button variant="secondary" size="sm" className="mx-2" onClick={() => {
                                                console.log("050124 history", history);
                                                console.log("050124 match", match);
                                                if (editField && editField.id){ 
                                                    history.push(`${match.url}/${editField.id}`);
                                                } else {
                                                    history.push(`${match.url}`);
                                                }
                                            }}>
                                                Close
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
}

export default EditZoneForm;
